import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import { statisticsStyles } from '../../Styles/statisticsStyles';
import Loader from 'react-loader-spinner'
import '../../Styles/datePickerStyles.css';
//import {XAxis, XYPlot, YAxis, LineMarkSeries } from 'react-vis';
//import 'react-vis/dist/style.css'

@inject('statisticsStore', 'commonStore')
@observer
class ChartComponent extends React.Component {

    render() {
        const { classes } = this.props;
        const { inProgress } = this.props.statisticsStore;
        if (inProgress)
            return (
                <div style={{ height: '100%' }}>
                    <div><Loader height={100} width={100} color={this.props.theme.palette.blue} className={classes.loading} timeout={100000} /></div>
                </div>
            )
        return (
            <div >
                {/*<XYPlot
                    xType="time"
                    width={800}
                    height={300}>
                    <XAxis title="X Axis" />
                    <YAxis title="Y Axis" />
                    <LineMarkSeries
                        data={[
                            { x: new Date('01/01/2018'), y: 75 },
                            { x: new Date('01/14/2018'), y: 60 },
                            { x: new Date('03/18/2018'), y: 80 },
                            { x: new Date('04/15/2018'), y: 90 }
                        ]} />
                    <LineMarkSeries
                        data={[
                            { x: new Date('01/01/2018'), y: 34 },
                            { x: new Date('01/14/2018'), y: 35 },
                            { x: new Date('03/18/2018'), y: 213 },
                            { x: new Date('04/12/2018'), y: 45 }
                        ]} />
                    </XYPlot>*/}
            </div >

        )
    }
}

export default withStyles(statisticsStyles, { withTheme: true })(withRouter(ChartComponent));
